import { css } from '@reown/appkit-ui';
export default css `
  wui-icon-box {
    height: ${({ spacing }) => spacing['16']};
    width: ${({ spacing }) => spacing['16']};
  }
`;
//# sourceMappingURL=styles.js.map